// removed by extract-text-webpack-plugin
module.exports = {"confidence_progress_bar":"confidence_progress_bar","confidence_progress_bar_name":"confidence_progress_bar_name","confidence_progress_bar_wrapper":"confidence_progress_bar_wrapper","confidence_progress_bar_percent":"confidence_progress_bar_percent","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ConfidenceProgressBar/style.scss
// module id = 1330
// module chunks = 0